var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-action-sheet',{on:{"close":_vm.closeAction},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"content"},[_c('van-picker',{attrs:{"title":"请选择","columns":_vm.columns,"show-toolbar":""},on:{"confirm":_vm.onConfirm,"cancel":_vm.onCancel}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }